<div class="route-splash" role="status" aria-live="polite">
  <div class="ring-wrap">
    <svg viewBox="0 0 120 120" class="ring" aria-hidden="true">
      <circle cx="60" cy="60" r="46" class="track" />
      <circle cx="60" cy="60" r="46" class="arc" />
    </svg>
    <img class="logo" src="/assets/images/brand/logo.png" alt="" />
  </div>
</div>
